import { Component, OnInit } from '@angular/core';
import { EmpGrievanceHttpService } from '../emp-grievance-http.service';

@Component({
  selector: 'app-emp-grievance-header',
  templateUrl: './emp-grievance-header.component.html',
  styleUrls: ['./emp-grievance-header.component.scss']
})
export class EmpGrievanceHeaderComponent  implements OnInit {
  isCollapsed: boolean = false;
  campusName: string | null;
  userName: string | null;

  constructor(private Service: EmpGrievanceHttpService) {
    this.Service.collapsed$.subscribe(data => {
      this.isCollapsed = data;
    });
  }
  ngOnInit(): void {
    this.campusName = localStorage.getItem('campusName');
    this.userName = localStorage.getItem('userName');

  }
  logOut() {
    const logoutPage = localStorage.getItem('logoutPage')
    if (logoutPage) {
      window.location.href = logoutPage;
    }
  }

  toggleCollapse() {
    this.Service.toggleCollapse();
    // const newWidth = this.isCollapsed ? '100%' : '92%';
    // this.Service.updateWidth(newWidth);
  }
}
